import incomeAndExpenditureScheduleMonthlyPage from './incomeAndExpenditureScheduleMonthlyPage';

export default incomeAndExpenditureScheduleMonthlyPage;